import React from 'react';
import Select from 'react-select';
import {
  Grid,
  Container,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import { validateLedgerCurrentYear } from 'utils/validationUtils';
import Loader from 'utils/Loader';
import LedgerDivCPIController from 'pages/Controller/LedgerDivCPIController';

const LedgerDivCPI = () => {
  const {
    ledgerData,
    formData,
    cloading,
    errors,
    customeroptions,
    profitCenters,
    selectedProfitCenter,
    handleCustomerChange,
    handleSubmit,
    handleInputChange,
    handleDownloadAll,
    handleProfitCenterChange
  } = LedgerDivCPIController(
    {
      customer: '',
      profitCenters: ''
    },
    validateLedgerCurrentYear
  );

  return (
    <div className="bg" style={{ display: 'block' }}>
      {cloading ? (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Please Wait....</span>
        </div>
      ) : null}
      <Container>
        <div className="cutrange">
          <span className="font20">Division Wise Ledger</span>
        </div>

        <Grid container spacing={2} sx={{ mb: 2 }}>
          {JSON.parse(localStorage.getItem("user")).userVerticalId !== "Garment" && (
            <>
              <Grid item xs={JSON.parse(localStorage.getItem("user")).profitCenter ? 4 : 8}>
                <Select
                  options={customeroptions} // Options for the dropdown
                  value={formData.customer} // Selected value
                  onChange={handleCustomerChange} // Handle selection change
                  placeholder="Select Party"
                  isClearable // Option to clear the selected value
                  menuPortalTarget={document.body} // Render the dropdown outside the table's container
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }} // Ensure dropdown is above other elements
                  onInputChange={handleInputChange}
                />
                {errors.customer == null || errors.customer === '' ? (
                  <p className="no-error">.</p>
                ) : (
                  <p className="error">{errors.customer}</p>
                )}
              </Grid>

              {JSON.parse(localStorage.getItem("user")).profitCenter != null && (
                <Grid item xs={4}>
                  <Select
                    options={profitCenters} // Options for the dropdown
                    value={selectedProfitCenter} // Selected value
                    onChange={handleProfitCenterChange} // Handle selection change
                    placeholder="Select Profit Center"
                    menuPortalTarget={document.body} // Render the dropdown outside the table's container
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }} // Ensure dropdown is above other elements
                    onInputChange={handleInputChange}
                  />
                  {errors.profitCenters == null || errors.profitCenters === '' ? (
                    <p className="no-error">.</p>
                  ) : (
                    <p className="error">{errors.profitCenters}</p>
                  )}
                </Grid>
              )}

              <Grid item xs={2}>
                <Button fullWidth variant="contained" color="primary" onClick={handleSubmit}>
                  GO
                </Button>
              </Grid>
            </>
          )}

          <Grid item xs={2}>
            <Button fullWidth variant="contained" color="primary" onClick={handleDownloadAll}>
              Download All
            </Button>
          </Grid>
        </Grid>

        {/* Party Information Box */}
        {/* <Paper elevation={3} sx={{ padding: '16px', backgroundColor: '#fff', mb: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <strong>Party Name :</strong> {ledgerData?.partyDetails?.name || ''}
            </Grid>
            <Grid item xs={6}>
              <strong>Zone :</strong> {ledgerData?.partyDetails?.zone || ''}
            </Grid>
            <Grid item xs={6}>
              <strong>Party Code :</strong> {ledgerData?.partyDetails?.partyCode || ''}
            </Grid>
            <Grid item xs={6}>
              <strong>City :</strong> {ledgerData?.partyDetails?.city || ''}
            </Grid>
          </Grid>
        </Paper> */}

        {/* Ledger Table */}
        <TableContainer component={Paper} sx={{ maxHeight: '63vh', overflowY: 'auto' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Posting Date
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Bill No.
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Reference Doc. No.
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Doc. Date
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Profit Centre
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Type
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Dr. Amount
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Cr. Amount
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Balance
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  FI Doc
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Clear Bill Doc
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Trf. Bill
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Sales Crno.
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Scheme Crno.
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Particular
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ledgerData?.transactions?.map((transaction, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: index % 2 === 0 ? '#ffffff' : '#e0e0e0' // Zebra-striping effect
                  }}
                >
                  <TableCell align="center">{transaction.postingDate}</TableCell>

                  <TableCell align="center">
                    {transaction.billNo && transaction.billNoURL ? (
                      <a href={transaction.billNoURL} target="_blank" rel="noopener noreferrer">
                        {transaction.billNo}
                      </a>
                    ) : transaction.billNo ? (
                      transaction.billNo
                    ) : (
                      ''
                    )}
                  </TableCell>

                  <TableCell align="center">
                    {transaction.referenceDocNo && transaction.referenceDocNoURL ? (
                      <a href={transaction.referenceDocNoURL} target="_blank" rel="noopener noreferrer">
                        {transaction.referenceDocNo}
                      </a>
                    ) : transaction.referenceDocNo ? (
                      transaction.referenceDocNo
                    ) : (
                      ''
                    )}
                  </TableCell>

                  <TableCell align="center">{transaction.docDate}</TableCell>
                  <TableCell align="center">{transaction.profitCentre || ''}</TableCell>
                  <TableCell align="center">{transaction.type}</TableCell>
                  <TableCell align="center">{transaction.drAmount}</TableCell>
                  <TableCell align="center">{transaction.crAmount}</TableCell>
                  <TableCell align="center">{transaction.balance}</TableCell>

                  <TableCell align="center">
                    {transaction.fiDoc && transaction.fiDocURL ? (
                      <a href={transaction.fiDocURL} target="_blank" rel="noopener noreferrer">
                        {transaction.fiDoc}
                      </a>
                    ) : transaction.fiDoc ? (
                      transaction.fiDoc
                    ) : (
                      ''
                    )}
                  </TableCell>

                  <TableCell align="center">
                    {transaction.clearBillDoc && transaction.clearBillDocURL ? (
                      <a href={transaction.clearBillDocURL} target="_blank" rel="noopener noreferrer">
                        {transaction.clearBillDoc}
                      </a>
                    ) : transaction.clearBillDoc ? (
                      transaction.clearBillDoc
                    ) : (
                      ''
                    )}
                  </TableCell>

                  <TableCell align="center">
                    {transaction.trfBill && transaction.trfBillURL ? (
                      <a href={transaction.trfBillURL} target="_blank" rel="noopener noreferrer">
                        {transaction.trfBill}
                      </a>
                    ) : transaction.trfBill ? (
                      transaction.trfBill
                    ) : (
                      ''
                    )}
                  </TableCell>

                  <TableCell align="center">
                    {transaction.SalesCrno && transaction.SalesCrnoURL ? (
                      <a href={transaction.SalesCrnoURL} target="_blank" rel="noopener noreferrer">
                        {transaction.SalesCrno}
                      </a>
                    ) : transaction.SalesCrno ? (
                      transaction.SalesCrno
                    ) : (
                      ''
                    )}
                  </TableCell>

                  <TableCell align="center">
                    {transaction.schemecrno && transaction.schemecrnoURL ? (
                      <a href={transaction.schemecrnoURL} target="_blank" rel="noopener noreferrer">
                        {transaction.schemecrno}
                      </a>
                    ) : transaction.schemecrno ? (
                      transaction.schemecrno
                    ) : (
                      ''
                    )}
                  </TableCell>

                  <TableCell align="center">{transaction.particular}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </div>
  );
};

export default LedgerDivCPI;